// extracted by mini-css-extract-plugin
export default {"search":"search_search__52Mr-","icon":"search_icon__mSvZZ","input":"search_input__KEVy4","separator":"search_separator__Xbjlp"};